<div *ngIf="msgList.length > 0" class="error-message-box">
    <div class="alert alert-danger alert-dismissible" role="alert" *ngFor="let msg of msgList">
        {{ getMessage(msg) }}
    </div>
</div>